module.exports = __webpack_public_path__ + "static/media/email.c52faab9.svg";